<div class="cnt-page-internal">
  <div class="row-title">
    <teiasoft-title [title]="'enquiryBook.frozen-title' | translate"></teiasoft-title>
  </div>
  <!-- TOOLBAR -->
  <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
    style="width: 100%;"></teiasoft-toolbar>

  <teiasoft-grid-odata [columnsToHideGOD]="columnsToHide" [oDataUrl]="oDataUrl" [odataEntity]="'VEnquiry'"
    [sortable]="true" [theme]="globals.theme!" style="width:100%" [selectable]="false" [disableAllSelection]="true"
    [filterable]="showFilters" [clearFilters]="clearFilters" [dateFormat]="globals.dateFormat!"
    [dateTimeFormat]="globals.dateTimeFormat!"
    [gridConfiguration]="gridConfiguration" [autoWidth]="true" [paginable]="true" [customIcoCols]="customIcoCols"
    (onCloseDialogSettings)="showSettingsDialog = false" (onUpdateConfiguration)="onUpdateConfiguration($event)"
    (customIconClick)="customIconClick($event)" [rowsPerPage]="50" [expandedEnquiryNo]="expandedEnquiryNo"
    [dataSetRow]="dataSetItems" [columnsToShowRow]="columnsToShowRowExpand" [showSettingsDialog]="showSettingsDialog"
    [refreshGridKey]="refreshGridKey" [selectable]="false" [enableDoubleClick]="true"
    [disableAllSelection]="false" [calculatedCols]="calculatedCols" [roundDigits]="roundDigitsForGrid"
    [roundDigitsItems]="roundDigitsForItemGrid" [customRenderers]="customRenderers"
    [headerParametersValues]="headerParametersValues" [filtersToHide]="filtersToHide"
    (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)">
  </teiasoft-grid-odata>
</div>
<teiasoft-modal (onConfirmClick)="onConfirmModal($event)" [theme]="globals.theme!"
  [isMobile]="!globals.isDesktop!"></teiasoft-modal>


<!-- custom grid cells -->
<ng-template #viewCost let-row let-column="column" let-uomColumn="uomColumn">
  <div class="extra-cost-row">
    <span style="margin-right: 0.2vw;">{{row[column] && row[column].toFixed(2)}}</span>
    <span> {{row[column] && row[column] >= 0 ? row[uomColumn || 'costsUom'] : ''}}</span>
  </div>
</ng-template>
<ng-template #viewExtraCosts let-row>
  <div class="extra-cost-row">
    <span style="margin-right: 0.2vw;">{{row.extraCosts!! && row.extraCosts.toFixed(2)}}</span>
    <span> {{row.extraCosts > 0 ? row.costsUom : ''}}</span>
    <div *ngIf="row.extraCosts" class="extra-cost-ico-cell"><i 
        class="extra-cost-icon fal fa-magnifying-glass"></i></div>
  </div>
</ng-template>
<ng-template #viewDeliveryDates let-row>
  <div class="extra-cost-row">
    <span style="margin-right: 0.1vw;">{{getItemRowMinDeliveryDate(row)}}</span>
  </div>
</ng-template>
